import 'antd/dist/antd.css'
import './index.less'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import registerServiceWorker from './registerServiceWorker'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/lib/locale-provider/zh_CN'
// import zhCN from 'antd/es/locale/zh_CN';
import MainPageLayout from './layout/main-page-layout'
import MainPageRoute from './layout/main-page'
import Login from './pages/login/login'
import moment from 'moment';
import Complaint from './pages/returnGoods/complaint'
import WaitBuyOrderDetails from './pages/orderAdmin/waitBuyOrderDetails'
import DeliverDetails from './pages/deliverGoods/deliverDetails'
import WithPrint from './pages/deliverGoods/withPrint'
import DeliverDetailsNew from './pages/deliverGoodsNew/deliverDetails'
import WithPrintNew from './pages/deliverGoodsNew/withPrint'
import { ConfigProviderWrap } from '@ant-design/pro-provider';
moment.locale('zh-cn');
ReactDOM.render(
  <BrowserRouter>
    <ConfigProvider locale={zhCN}>
      <ConfigProviderWrap>
      <Switch>
        <Route path="/login" component={Login} />
        <Route path="/complaint" component={Complaint} />
        <Route path="/waitBuyOrderDetails" component={WaitBuyOrderDetails}/>
        <Route path="/deliverDetails" component={DeliverDetails}/>
        <Route path="/withPrint" component={WithPrint}/>
        <Route path="/deliverDetailsNew" component={DeliverDetailsNew}/>
        <Route path="/withPrintNew" component={WithPrintNew}/>
        <MainPageRoute path="/" component={MainPageLayout} />
      </Switch>
      </ConfigProviderWrap>
    </ConfigProvider>
  </BrowserRouter>
  , document.getElementById('root'))

// service worker是在后台运行的一个线程，可以用来处理离线缓存、消息推送、后台自动更新等任务。
// registerServiceWorker就是为react项目注册了一个service worker，用来做资源的缓存，这样你下次访问时，就可以更快的获取资源。
// 而且因为资源被缓存，所以即使在离线的情况下也可以访问应用（此时使用的资源是之前缓存的资源）。
// 注意，registerServiceWorker注册的service worker 只在生产环境中生效（process.env.NODE_ENV === 'production'）
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js